import { render, staticRenderFns } from "./CriarReceita.vue?vue&type=template&id=73542640&"
import script from "./CriarReceita.vue?vue&type=script&lang=js&"
export * from "./CriarReceita.vue?vue&type=script&lang=js&"
import style0 from "./CriarReceita.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports